import { restore, createEvent } from "effector";
import { persist } from "effector-storage/session";

export const setLocation = createEvent<number | null>();

export const $location = restore(setLocation, null);
persist({ store: $location, key: "location" });
